export type CourierTaxRegistration = { type: string; number: string; issuer_country: string };
export type CourierCustoms = {
  provider: 'dhl_express' | 'ups' | 'fedex';
  invoice_number: string; invoice_date: string; terms: 'DAP' | 'DDP'; freight_value: number;
  shipper_registration: CourierTaxRegistration | null; receiver_registration: CourierTaxRegistration | null;
  related_parties: boolean;
};
export const courierRegistrationOptions = {
  dhl_express: [{ label: 'EORI customs number', value: 'EOR' }, { label: 'VAT tax number', value: 'VAT' }, { label: 'Employer tax number', value: 'EIN' }],
  ups: [{ label: 'EORI customs number', value: 'EORI' }, { label: 'Business tax number', value: 'BUSINESS' }, { label: 'Personal tax number', value: 'PERSONAL' }],
  fedex: [{ label: 'EORI / business union number', value: 'BUSINESS_UNION' }, { label: 'Business national tax number', value: 'BUSINESS_NATIONAL' },
    { label: 'Federal tax number', value: 'FEDERAL' }, { label: 'Personal national tax number', value: 'PERSONAL_NATIONAL' }],
};
